import { render, staticRenderFns } from "./EditStudentData.vue?vue&type=template&id=295f043c&scoped=true&"
import script from "./EditStudentData.vue?vue&type=script&lang=js&"
export * from "./EditStudentData.vue?vue&type=script&lang=js&"
import style0 from "./EditStudentData.vue?vue&type=style&index=0&id=295f043c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f043c",
  null
  
)

export default component.exports